import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FindOptions } from 'api';
import { EntityContactRequestApi } from 'api/entityContactRequest';

export const filterEntityContactRequest = createAsyncThunk(
  'entityContactRequest/filterEntityContactRequest',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await EntityContactRequestApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityContactRequestStatus = createAsyncThunk(
  'entityContactRequest/updateEntityContactRequestStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityContactRequestApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
  isLoaded: boolean;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
  isLoaded: false,
};

const entityContactRequestSlice = createSlice({
  name: 'entityContactRequest',
  initialState,
  reducers: {
    reloadEntityContactRequest(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityContactRequest(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityContactRequest(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entityContactRequestReducer } =
  entityContactRequestSlice;

export const {
  reloadEntityContactRequest,
  updateSavedListEntityContactRequest,
  updateSavedPaginationEntityContactRequest,
} = actions;

export default entityContactRequestReducer;
